module.exports = __webpack_public_path__ + "img/krzyz_galeria.a23731dc.jpg";